import React from 'react';
import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import { Button } from '@kurtosys/ksys-app-components/dist/components/base/Button/Button';
import { IButtonProps } from '@kurtosys/ksys-app-components/dist/components/base/Button/models/IButtonProps';
import { propagateChanged } from 'mobx/lib/internal';

const CloseButton = (props: IButtonProps) => {
	const { appStore, ...buttonProps } = props as any;
	return <Button { ...buttonProps } />;
};

export default InjectedStyledComponent(CloseButton, 'overlay', ['closeButton']);